

define(['angular', 'squid/index', 'components/xo-beaver/dist/logger'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-login-props', ['squid']).factory('$loginProps', function ($rootScope, $window, $logger) {

        var RISKY_LOGIN_TITLE = {
            ECONSENT_REQUIRED: '',
            ELV_DECLINE: '',
            EXPIRED_CREDIT_CARD: 'login.riskyLoginUpdateCard',
            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: '',
            NEED_CREDIT_CARD: 'login.riskyLoginAddCard',
            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: 'login.riskyLoginAddFi',
            NEED_CONFIRMED_CARD: '',
            NEED_AUTHENTICATED_CARD: 'login.riskyLoginUpdateCard',
            NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShipping',
            PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhone',
            PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassed',
            SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepa',
            TAX_ID_REQUIRED: ''
        };
        var RISKY_LOGIN_SUBTITLE = {
            EXPIRED_CREDIT_CARD: 'login.riskyLoginExpiredCardST',
            NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShippingST',
            PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhoneST',
            SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepaST',
            PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassedST'
        };

        return {
            mapInfo: function mapInfo(contingency) {
                var contingencyTitle = RISKY_LOGIN_TITLE[contingency] ? RISKY_LOGIN_TITLE[contingency] : 'login.loginContingency';
                var contingencySubTitle = RISKY_LOGIN_SUBTITLE[contingency];
                return { title: contingencyTitle, subtitle: contingencySubTitle };
            },

            inList: function inList(contingency) {
                return RISKY_LOGIN_TITLE.hasOwnProperty(contingency);
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/login/props.js
// module id = ./components/xo-login-components/src/login/props.js
// module chunks = 1